import { useModals } from "@/features/modals/hooks";
import { convertAppointmentToProject } from "@repo/api";
import { Button } from "@repo/skapa";
import { t } from "@repo/translation";
import { useToast } from "@repo/ui";
import { getDebugMessage } from "@repo/utils";
import { useState } from "react";
import { type NavigateFunction } from "react-router-dom";

import { type AppointmentModalState } from "./AppointmentModalReducer";

export const ConvertToProjectButton = ({
  state,
  closeModal,
  navigate,
}: {
  state: AppointmentModalState;
  navigate: NavigateFunction;
  closeModal: () => void;
}) => {
  const { pushModal } = useModals();
  const { updateToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleConvertToProject = () => {
    const appointment = state.appointment;
    const id = appointment?.id || appointment?.appointmentId;
    const paramName = appointment?.id
      ? "internalAppointmentId"
      : appointment?.appointmentId
        ? "appointmentId"
        : null;

    if (!id || !paramName) {
      return;
    }

    pushModal({
      type: "CONFIRM",
      onConfirm: async () => {
        setIsLoading(true);
        try {
          const project = await convertAppointmentToProject(id, paramName);
          updateToast({ title: t("prompt.appointment_saved") });

          if (project) {
            navigate(`/opportunity/${project.id}/`);
          }
        } catch (err) {
          updateToast({
            title: t("prompt.convert_to_project_failed"),
            message: getDebugMessage(err),
            type: "error",
          });
        } finally {
          closeModal();
          setIsLoading(false);
        }
      },
      title: t("action.convert_to_project"),
      message: appointment?.reasonCode
        ? t(`reason_code.${appointment.reasonCode}`)
        : "",
    });
  };

  return (
    <Button
      type="primary"
      text={t("action.create_new_project")}
      loading={isLoading}
      onClick={handleConvertToProject}
    />
  );
};
